import React from "react";
import { BarChart3 } from "lucide-react";

// Sumarized Income Statement Data
const IncomeStatementInfo = [
  { metric: "Year", values: ["2022", "2023", "2024"], bold: true, isHeader: true },
  { metric: "Revenue", values: ["$1,800,000", "$2,200,000", "$2,600,000"], bold: false },
  { metric: "Cost of Goods Sold (COGS)", values: ["$720,000", "$880,000", "$1,040,000"], bold: false },
  { metric: "Gross Profit", values: ["$1,080,000", "$1,320,000", "$1,560,000"], bold: true },
  { metric: "Operating Expenses", values: ["$620,000", "$750,000", "$870,000"], bold: false },
  { metric: "EBITDA", values: ["$460,000", "$570,000", "$690,000"], bold: true },
  { metric: "Depreciation & Amortization", values: ["$80,000", "$95,000", "$110,000"], bold: false },
  { metric: "Operating Income (EBIT)", values: ["$380,000", "$475,000", "$580,000"], bold: true },
  { metric: "Interest Expense", values: ["$20,000", "$25,000", "$30,000"], bold: false },
  { metric: "Non-Operating Income", values: ["$15,000", "$20,000", "$25,000"], bold: false },
  { metric: "Pre-Tax Income", values: ["$375,000", "$470,000", "$575,000"], bold: true },
  { metric: "Income Tax Expense", values: ["$90,000", "$112,000", "$138,000"], bold: false },
  { metric: "Net Income", values: ["$285,000", "$358,000", "$437,000"], bold: true },
  { metric: "Dividends Paid", values: ["$50,000", "$60,000", "$70,000"], bold: false },
  { metric: "Retained Earnings", values: ["$235,000", "$298,000", "$367,000"], bold: true },
];

// Summarized Income Statement Component
const SummarizedIncomeStatement = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6 mb-8">
      {/* Header */}
      <div className="flex items-center space-x-2 mb-6">
        <BarChart3 className="h-6 w-6 text-blue-600" />
        <h3 className="text-lg font-medium text-gray-900">Summarized Income Statement</h3>
      </div>
      <p className="text-sm text-gray-600 mb-4">
        Income Statement (Last 3 Years) – (Amounts in USD, thousands)
      </p>

      {/* Income Statement Table */}
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          {/* Table Header */}
          <thead className="bg-gray-100">
            <tr>
              <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Metric</th>
              {IncomeStatementInfo[0].values.map((year, index) => (
                <th key={index} className="border border-gray-300 px-4 py-2 text-center font-semibold">
                  {year}
                </th>
              ))}
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {IncomeStatementInfo.slice(1).map((item, index) => (
              <tr key={index} className="border-b border-gray-300">
                <td className={`border border-gray-300 px-4 py-2 ${item.bold ? "font-bold" : ""}`}>
                  {item.metric}
                </td>
                {item.values.map((value, i) => (
                  <td key={i} className="border border-gray-300 px-4 py-2 text-center">
                    {value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SummarizedIncomeStatement;
